// utils
import _ from 'lodash';
// consts
import { PAD_ITEM_STATE } from 'app/config/pad_item.js';

export default class PadItemState {
  /**
   * @param {object} state - pad creator element state
   * @returns {this}
   */
  constructor(state) {
    this._state = _.cloneDeep(state);
    this._screenData = _.cloneDeep(state.data.screen);
    this._loadedData = _.cloneDeep(state.data.loaded);
  }

  /**
   * Find index array by code
   * @param {String} code - element's code to check
   * @returns {number} index
   */
  _findIndexByCode(code, arr) {
    return arr.findIndex(item => item.code === code);
  }

  _hasBeenElementCreated() {
    const { id } = this._loadedData;
    let thereAreId = !id;

    return thereAreId;
  }

  _hasBeenElementUpdated(padItem) {
    const { code } = padItem;
    const indexScreen = this._findIndexByCode(code, this._screenData);
    const indexLoaded = this._findIndexByCode(code, this._loadedData);

    if (indexLoaded === -1) return false;
    if (indexScreen === -1) return false;

    const isDifferentFromTheOriginal =
      JSON.stringify(this._screenData[indexScreen]) !==
      JSON.stringify(this._loadedData[indexLoaded]);
    return isDifferentFromTheOriginal;
  }

  _hasBeenElementSuspended() {
    const { status } = this._loadedData;
    const thereAreStatus = !_.isEmpty(this._loadedData) && !status;
    return thereAreStatus;
  }

  getPadItemType(padItem) {
    let eventTypeName = null;

    const eventType = () => {
      const hasItemUpdated = this._hasBeenElementUpdated(padItem);
      const hasItemCreated = this._hasBeenElementCreated();
      const hasItemSuspended = this._hasBeenElementSuspended(padItem);

      if (hasItemUpdated) {
        return (eventTypeName = PAD_ITEM_STATE.CHANGED);
      } else if (hasItemCreated) {
        return (eventTypeName = PAD_ITEM_STATE.CREATED);
      } else if (hasItemSuspended) {
        return (eventTypeName = PAD_ITEM_STATE.SUSPENDED);
      }
      return eventTypeName;
    };

    return eventType();
  }
}
